import React from "react";
import "./appPromptModal.css";

export const APP_STORE_URL =
  "https://apps.apple.com/us/app/invest-with-knowledge/id6761795259";

function AppPromptModal({ isOpen, onClose }) {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="app-prompt-overlay" role="dialog" aria-modal="true">
      <section className="app-prompt-card">
        <h3>Get the app!</h3>
        <p>
          Get the Weekly Fave and status change alerts sent straight to your
          phone with Invest With Knowledge for iPhone.
        </p>
        <p className="app-prompt-note">iOS only for now. Android coming soon!</p>

        <div className="app-prompt-actions">
          <a
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="app-prompt-link"
            onClick={onClose}
          >
            Download on the App Store
          </a>
          <button type="button" onClick={onClose} className="app-prompt-skip-button">
            Maybe later
          </button>
        </div>
      </section>
    </div>
  );
}

export default AppPromptModal;
